import { graphql } from "gatsby";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import styled, { keyframes } from "styled-components";

import WillhabenLogo from "../assets/partners/willhaben.png";
import MiraclLogo from "../assets/elements/MiraclLogo";
import { BlankPage } from "../components/Layout";
import { colors } from "../constants/colors";
import { breakpoints } from "../constants/breakpoints";

const REDIRECT_URL =
    "https://" +
    process.env.GATSBY_SURVEY_HOST +
    ".miracl.at/survey?utm_medium=willhaben&utm_source=media&utm_content=desktop&utm_campaign=calculator";

const Willhaben = () => {
    useEffect(() => {
        const timeout = setTimeout(() => {
            window.location.href = REDIRECT_URL;
        }, 1500);

        return () => clearTimeout(timeout);
    }, []);

    return (
        <>
            <Helmet>
                <style>{`.ch2 { display: none !important; }`}</style>
            </Helmet>
            <BlankPage>
                <Wrapper>
                    <LogoWrapper>
                        <WillhabenImg src={WillhabenLogo} alt="willhaben" />
                        <Dots>
                            <Dot />
                            <Dot />
                            <Dot />
                        </Dots>
                        <MiraclLogoWrapper>
                            <MiraclLogo width="100%" height="100%" />
                        </MiraclLogoWrapper>
                    </LogoWrapper>
                    <Subtitle>Weiter, um für dich die beste Finanzierung zu finden</Subtitle>
                </Wrapper>
                <BottomLink href={REDIRECT_URL}>Direkt weiter</BottomLink>
            </BlankPage>
        </>
    );
};

const Wrapper = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
`;

const LogoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;

    @media (max-width: ${breakpoints.mobileMax}) {
        gap: 20px;
    }
`;

const WillhabenImg = styled.img`
    height: 120px;
    width: auto;

    @media (max-width: ${breakpoints.mobileMax}) {
        height: 72px;
    }
`;

const MiraclLogoWrapper = styled.div`
    width: 210px;
    height: 50px;

    @media (max-width: ${breakpoints.mobileMax}) {
        width: 126px;
        height: 30px;
    }
`;

const Subtitle = styled.p`
    margin: 0;
    text-align: center;
    font-size: 16px;
    color: #303044;
    font-weight: 600;

    @media (max-width: ${breakpoints.mobileMax}) {
        font-size: 14px;
        padding: 0 24px;
    }
`;

const BottomLink = styled.a`
    display: block;
    text-align: center;
    padding: 24px 0;
    font-size: 16px;
    font-weight: 600;
    color: #8d90a4;

    &:hover {
        color: ${colors.primary};
    }
`;

const connect = keyframes`
    0%, 100% {
        opacity: 0.2;
        transform: scale(0.7);
    }
    40% {
        opacity: 1;
        transform: scale(1);
    }
`;

const Dots = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    @media (max-width: ${breakpoints.mobileMax}) {
        gap: 8px;
    }
`;

const Dot = styled.span`
    width: 12px;
    height: 12px;
    border-radius: 50%;

    @media (max-width: ${breakpoints.mobileMax}) {
        width: 8px;
        height: 8px;
    }

    background-color: ${colors.primary};
    opacity: 0.2;
    animation: ${connect} 1.4s ease-in-out infinite;

    &:nth-child(1) {
        animation-delay: 0s;
    }

    &:nth-child(2) {
        animation-delay: 0.25s;
    }

    &:nth-child(3) {
        animation-delay: 0.5s;
    }
`;

export default Willhaben;

export const query = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { ns: { in: ["header", "footer"] }, language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
    }
`;
